const LIST_QUERY = `
  query ListSyncEvents($paginationParams: PaginationInput!) {
    listSyncEvents(pagination: $paginationParams) {
      objects {
        startTime
        endTime
      }
    }
  }
`

const CREATE_MUTATION = `
  mutation CreateSyncEvent($credentialUUID: String, $startTime: String!) {
    createSyncEvent(credentialUUID: $credentialUUID, startTime: $startTime) {
      startTime
    }
  }
`

const syncEventQueries = {
  methods: {
    async listSyncEventsQuery(paginationParams) {
      try {
        const result = await this.graphQuery(LIST_QUERY, {paginationParams})
        const {objects} = result.listSyncEvents
        return objects
      } catch (error) {
        throw new Error(error)
      }
    },
    async createSyncMutation(options) {
      try {
        const result = await this.graphQuery(CREATE_MUTATION, options)
        return result.createSyncEvent
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default syncEventQueries
